import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { VoicePicker } from "./VoicePicker";

// "Choose Voice" popup: two columns of voices with previews; Save applies the pick to this video.
export function VoiceDialog({ open, onOpenChange, voice, onSave }) {
  const [draft, setDraft] = useState(voice);
  useEffect(() => { if (open) setDraft(voice); }, [open, voice]);
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="voice-dialog" className="max-w-2xl">
        <DialogHeader><DialogTitle>Choose Voice</DialogTitle></DialogHeader>
        <VoicePicker voice={draft} setVoice={setDraft} />
        <div className="flex justify-end pt-2">
          <button type="button" onClick={() => { onSave(draft); onOpenChange(false); }} data-testid="voice-save-btn"
            className="bg-red-600 hover:bg-red-700 text-white text-sm font-semibold rounded-[4px] px-8 py-2.5 transition-colors">Save</button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
